/* __next_internal_client_entry_do_not_use__ default auto */ import * as React from 'react';
import createSvgIcon from "../../utils/createSvgIcon.js";
/**
 * @ignore - internal component.
 */ import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');
